import { useEffect, useMemo, useState } from "react";
import { NavLink, Outlet, useLocation, useSearchParams } from "react-router-dom";
import "../styles/DashboardLayout.scss";
import {
  getEffectiveAccessLevel,
  getProfile,
  isAdmin,
  subscribeAuthChange,
} from "../utils/auth";

const NAV_ITEMS = [
  { id: "main", label: "Главная", to: "/main" },
  { id: "projects", label: "Все проекты", to: "/projects" },
  { id: "services", label: "Сервисы", to: "/services" },
  { id: "members", label: "Участники", to: "/members" },
  { id: "profile", label: "Профиль", to: "/profile" },
];

const ADMIN_NAV_ITEM = { id: "admin", label: "Админка", to: "/admin" };

export default function DashboardLayout() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [, setAuthTick] = useState(0);
  const profile = getProfile();
  const isAdminUser = isAdmin(getEffectiveAccessLevel(profile));
  const navItems = useMemo(
    () => (isAdminUser ? [...NAV_ITEMS, ADMIN_NAV_ITEM] : NAV_ITEMS),
    [isAdminUser],
  );
  const isProfileContext =
    location.pathname.startsWith("/profile") ||
    (location.pathname.startsWith("/projects/") &&
      searchParams.get("from") === "profile");
  const isProjectsContext =
    location.pathname === "/projects" || location.pathname.startsWith("/projects/");

  useEffect(() => {
    setIsNavOpen(false);
  }, [location.pathname, searchParams]);

  useEffect(() => {
    const handleAuthChange = () => setAuthTick((prev) => prev + 1);
    const unsubscribe = subscribeAuthChange(handleAuthChange);
    window.addEventListener("storage", handleAuthChange);
    return () => {
      unsubscribe();
      window.removeEventListener("storage", handleAuthChange);
    };
  }, []);

  return (
    <div className="dashboard-layout">
      <header className="dashboard-header">
        <button
          className={`nav-toggle${isNavOpen ? " is-open" : ""}`}
          type="button"
          onClick={() => setIsNavOpen((prev) => !prev)}
          aria-label={isNavOpen ? "Закрыть меню" : "Открыть меню"}
          aria-expanded={isNavOpen}
          aria-controls="main-nav"
        >
          <span />
          <span />
          <span />
        </button>
        <nav
          id="main-nav"
          className={`main-nav${isNavOpen ? " main-nav--open" : ""}`}
          style={{ "--nav-cols": navItems.length }}
        >
          {navItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.to}
              onClick={() => setIsNavOpen(false)}
              className={({ isActive }) =>
                `main-nav__item${
                  (item.id === "profile" && isProfileContext) ||
                  (item.id === "projects" && !isProfileContext && isProjectsContext) ||
                  (!isProfileContext && !isProjectsContext && isActive)
                    ? " main-nav__item--active"
                    : ""
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      {isNavOpen && <div className="nav-scrim" onClick={() => setIsNavOpen(false)} />}
      <main className="main-content" key={location.pathname}>
        <Outlet />
      </main>
    </div>
  );
}
